var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"value":_vm.drawer,"fixed":"","app":"","dark":_vm.dark,"clipped":_vm.clipped},on:{"input":_vm.onInput}},[_c('v-list',{attrs:{"dense":""}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }